import { isValidDataKey } from '@utils/sagaResponseValidator';
export const isSchDriveLobbyMeeting = (data) => isValidDataKey(data, 'sch_drive_lobby', true);
